import React, { useEffect, useState, useMemo } from "react";
import { logEventos } from "../../../../services/services";
import moment from "moment";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Navbar from "../../../Navbar";
import { Container, Typography, Box, Button, MenuItem, createFilterOptions, ListItemIcon, Select, FormControl, InputLabel, Chip, FormControlLabel, Switch, Autocomplete, TextField, } from "@mui/material";
import { UrlApi } from "../../../../services/apirest";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Actualizar_precio_especial from "./Actualizar_precio_especial";
import AddPrecioEspecial from "./AddPrecioEspecial";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import Actualizar_selection from "./Actualizar_selection";
import Editar_lista from "./Editar_lista";
import { Edit } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

function Lista_preciosEspeciales() {
  const soloLectura = useLocation().pathname === "/ver_precios_especiales";
  const [lista, setLista] = useState(); // p/tabla
  const [tabla, setTabla] = useState(true);
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [actualizar, setActualizar] = useState(false);
  const [actualizarTodos, setActualizarTodos] = useState(false);
  const [datoslista, setDatoslista] = useState({});
  const globalTheme = useTheme();
  const [clienteSeleccionado, setclienteSeleccionado] = useState([]);
  const [rowSelection, setrowSelection] = useState({});
  const [editar, setEditar] = useState(false);

  // Solo las sucursales a las que el usuario está autorizado (localStorage "suc_auth").
  const sucursalesAutorizadas = useMemo(
    () => (localStorage.getItem("suc_auth") || "").split(","),
    [],
  );
  const listaAutorizada = useMemo(
    () =>
      Array.isArray(lista)
        ? lista.filter((item) =>
            sucursalesAutorizadas.includes(String(item.id_sucursal)),
          )
        : [],
    [lista, sucursalesAutorizadas],
  );

  const sucursalesUnicas = [...new Set(listaAutorizada.map((i) => i.sucursal))];
  // console.log("sucursalesUnicas",sucursalesUnicas)
  const segmentosUnicos = [...new Set(listaAutorizada.map((i) => i.segmento))];
  const [filtros, setFiltros] = useState({
    sucursales: [],
    segmentos: []
  });

  const [value, setValue] = useState([]);
  const filter = createFilterOptions();

  const handleChange = (campo, opcionesUnicas) => (_, newValue) => {
    if (newValue.find((option) => option.all)) {
      setFiltros((f) => ({
        ...f,
        [campo]: f[campo].length === opcionesUnicas.length ? [] : opcionesUnicas,
      }));
    } else {
      setFiltros((f) => ({ ...f, [campo]: newValue }));
    }
  };


  //*********************************** OBTENER **************************************************************************************************/
  const obtenerLista = async () => {
    // console.log("vulvo a obtener");

    await fetch(UrlApi + "/precios_especiales/lista_vigente")
      .then((data) => data.json())
      .then((data) => setLista(data));
  };

  //ejecuta la funcion de obtener
  useEffect(() => {
    obtenerLista();
  }, [tabla]);

  // useEffect(() => {
  //   // Crear el array de clientes seleccionados
  //   // const clienteSeleccionado = Object.keys(rowSelection)
  //   //   .filter((key) => rowSelection[key]) // Solo incluir las filas seleccionadas
  //   //   .map((key) => ({
  //   //     id_precioespecial: lista[key].id_precioespecial,
  //   //     id_cliente: lista[key].id_cliente,
  //   //     lt_sin_iva: lista[key].lt_sin_iva,
  //   //     lt_con_iva: lista[key].lt_con_iva,
  //   //     kg_sin_iva: lista[key].kg_sin_iva,
  //   //     kg_con_iva: lista[key].kg_con_iva,
  //   //     vigencia: lista[key].vigencia,
  //   //     fin_vigencia: lista[key].fin_vigencia,
  //   //     id_producto: lista[key].id_producto,
  //   //     densidad_autogas: lista[key].densidad_autogas,
  //   //     densidad_hipergas: lista[key].densidad_hipergas,
  //   //     id_empresa: lista[key].id_empresa,
  //   //     valor: lista[key].valor
  //   //   }));

  //   // setclienteSeleccionado(clienteSeleccionado);
  //   const clienteSeleccionado = Object.keys(rowSelection)
  //     .filter((id) => rowSelection[id]) // solo los seleccionados
  //     .map((id) => lista.find((item) => item.id_precioespecial === id));

  //   setclienteSeleccionado(clienteSeleccionado);
  // }, [rowSelection, lista,]);



  //********************************** TABLA ***************************************************************************************************/
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const columns = useMemo(
    () => [
      {
        header: " ",
        columns: [
          {
            header: "Cliente",
            accessorKey: "razon_social",
            accessorFn: c => c.sisven_id
              ? `(${c.sisven_id}) ${c.razon_social} (${c.nombre})`
              : `${c.razon_social} (${c.nombre})`,
            size: 190,

          },
          {
            header: "Segmento",
            accessorKey: "segmento",
            accessorFn: c => `${c.segmento}`,
            size: 85,

          },
          {
            header: "Sucursal",
            accessorKey: "sucursal",
            accessorFn: c => `${c.sucursal}`,
            size: 80,

          },

        ],
      },
      {
        header: "Precio del Litro",
        columns: [
          {
            header: "Sin IVA",
            accessorKey: "lt_sin_iva",
            size: 80,
            Cell: ({ cell }) =>
              Number(cell.getValue()).toLocaleString("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
          },
          {
            header: "Con IVA",
            accessorKey: "lt_con_iva",
            size: 80,
            Cell: ({ cell }) =>
              Number(cell.getValue()).toLocaleString("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
          },

        ],
      },
      {
        header: "Precio del Kilo",
        columns: [
          {
            header: "Sin IVA",
            accessorKey: "kg_sin_iva",
            size: 80,
            Cell: ({ cell }) =>
              Number(cell.getValue()).toLocaleString("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
          },
          {
            header: "Con IVA",
            accessorKey: "kg_con_iva",
            size: 80,
            Cell: ({ cell }) =>
              Number(cell.getValue()).toLocaleString("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
          },]
      },
      {
        header: "Vigencia",
        columns: [
          {
            header: "Inicio",
            accessorFn: (fecha) => moment(fecha.vigencia).format("DD-MM-YYYY"),
            size: 100,
          },
          {
            header: "Fin",
            accessorFn: (fecha) => fecha.fin_vigencia ? moment(fecha.fin_vigencia).format("DD-MM-YYYY") : "Sin registrar",
            size: 100,
          },
        ],
      },

    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  //*************************************************************************************************************************************/
  const handleClickActualizar = (rowData) => {
    setActualizar(true);
    setTabla(true);
    setDatoslista(rowData)

  };

  const handleActualizarTodos = (rowData) => {
    setActualizarTodos(true);
    setTabla(true);
  };

  const handleEditar = (rowData) => {
    setEditar(true);
    setTabla(true);
    setDatoslista(rowData)
  };

  const handleClickNuevo = () => {
    setAlta(true);
    setTabla(false);
  };

  useEffect(() => {
    logEventos(
      soloLectura
        ? "acceso al menú Ver lista de precios especiales"
        : "acceso al menú Lista de Precios Especiales",
      "Granel",
      soloLectura
        ? "Ver lista de precios especiales"
        : "Lista de Precios Especiales",
      localStorage.getItem("user"));
  }, [soloLectura]);

  const listaFiltrada = listaAutorizada.filter((item) => {
    const coincideSucursal =
      filtros.sucursales.length === 0 ||
      filtros.sucursales.includes(item.sucursal);
    const coincideSegmento =
      filtros.segmentos.length === 0 ||
      filtros.segmentos.includes(item.segmento);
    return coincideSucursal && coincideSegmento;
  });

  useEffect(() => {
    const listaFiltradaLocal = listaAutorizada.filter((item) => {
      const coincideSucursal =
        filtros.sucursales.length === 0 ||
        filtros.sucursales.includes(item.sucursal);
      const coincideSegmento =
        filtros.segmentos.length === 0 ||
        filtros.segmentos.includes(item.segmento);
      return coincideSucursal && coincideSegmento;
    });

    const clienteSeleccionado = Object.keys(rowSelection)
      .filter((id) => rowSelection[id])
      .map((id) =>
        listaFiltradaLocal.find(
          (item) => item.id_precioespecial === Number(id) // <- convertir a número
        )
      );

    setclienteSeleccionado(clienteSeleccionado);
  }, [rowSelection, listaAutorizada, filtros, value]);





  return (
    <div>
      <Navbar />
      <Container maxWidth="xl" mt={1} >
        {tabla ? (
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            gap={2}
            mt={2}
          >
            {/* 🔹 Filtro múltiple de sucursales
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Sucursal</InputLabel>
              <Select
                multiple
                value={filtros.sucursales}
                label="Sucursal"
                onChange={(e) =>
                  setFiltros((f) => ({ ...f, sucursales: e.target.value, }))
                }
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((v) => (
                      <Chip key={v} label={v} />
                    ))}
                  </Box>
                )}
              >
                {sucursalesUnicas.map((s) => (
                  <MenuItem key={s} value={s}>
                    {s}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* 🔹 Filtro múltiple de segmentos 
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Segmento</InputLabel>
              <Select
                label="Segmento"
                multiple
                value={filtros.segmentos}
                onChange={(e) =>
                  setFiltros((f) => ({
                    ...f,
                    segmentos: e.target.value,
                  }))
                }
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((v) => (
                      <Chip key={v} label={v} />
                    ))}
                  </Box>
                )}
              >
                {segmentosUnicos.map((seg) => (
                  <MenuItem key={seg} value={seg}>
                    {seg}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

            <Autocomplete
              multiple
              size="small"
              disableCloseOnSelect
              options={sucursalesUnicas}
              value={filtros.sucursales}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);
                return [{ title: "Seleccionar todas", all: true }, ...filtered];
              }}
              onChange={handleChange("sucursales", sucursalesUnicas)} // ✅ le pasás el campo y opciones
              getOptionLabel={(option) => option.title || option}
              renderOption={(props, option) => (
                <li {...props}>
                  {option.all ? (
                    <strong>
                      {filtros.sucursales.length === sucursalesUnicas.length
                        ? "Quitar selección"
                        : "Seleccionar todas"}
                    </strong>
                  ) : (
                    option.title || option
                  )}
                </li>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Box key={option} component="span" sx={{ mr: 0.5 }}>
                    <Chip label={option.title || option} {...getTagProps({ index })} />
                  </Box>
                ))
              }
              renderInput={(params) => (
                <TextField {...params} label="Sucursal" placeholder="Seleccionar..." />
              )}
              sx={{ minWidth: 200 }}
            />



            {/* 🔹 Filtro múltiple de segmentos */}
            <Autocomplete
              multiple
              size="small"
              disableCloseOnSelect
              options={segmentosUnicos}
              value={filtros.segmentos}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);
                return [{ title: "Seleccionar todos", all: true }, ...filtered];
              }}
              onChange={handleChange("segmentos", segmentosUnicos)} // ✅ igual que arriba
              getOptionLabel={(option) => option.title || option}
              renderOption={(props, option) => (
                <li {...props}>
                  {option.all ? (
                    <strong>
                      {filtros.segmentos.length === segmentosUnicos.length
                        ? "Quitar selección"
                        : "Seleccionar todos"}
                    </strong>
                  ) : (
                    option.title || option
                  )}
                </li>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Box key={option} component="span" sx={{ mr: 0.5 }}>
                    <Chip label={option.title || option} {...getTagProps({ index })} />
                  </Box>
                ))
              }
              renderInput={(params) => (
                <TextField {...params} label="Segmento" placeholder="Seleccionar..." />
              )}
              sx={{ minWidth: 200 }}
            />




            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setFiltros({ sucursales: [], segmentos: [] });
                setrowSelection({});
              }}
            >
              Limpiar filtros
            </Button>

          </Box>
        ) : null}
        {lista && tabla ? (
          <Box mt={2} boxShadow={3} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                enableColumnResizing
                columns={columns}
                enableRowActions={!soloLectura}
                state={{ rowSelection }}
                onRowSelectionChange={setrowSelection}
                getRowId={(row) => row.id_precioespecial}
                //   data={lista}
                data={listaFiltrada}
                enableRowSelection={
                  soloLectura ? false : (row) => row.original.fin_vigencia === null
                }
                initialState={initialState}
                positionActionsColumn="last"
                enableExpandAll={false}
                enableToolbarInternalActions={true}
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    color: "black",
                    borderColor: "black",
                    backgroundColor: "white"
                  },
                })}
                enableColumnActions={false}
                selectAllMode="all"
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                positionToolbarAlertBanner="top"
                renderTopToolbarCustomActions={() => (
                  <>
                    {!soloLectura && (
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddBoxTwoToneIcon />}
                        onClick={handleClickNuevo}
                      >
                        Nuevo Precio
                      </Button>
                    )}
                    <Typography variant="poster" fontSize={26}>
                      Lista de Precios Especiales
                    </Typography>

                    {!soloLectura && clienteSeleccionado.length ? (
                      <Button variant="contained" color="secondary" onClick={handleActualizarTodos}>
                        Actualizar Precio
                      </Button>
                    ) : null}
                  </>
                )}
                layoutMode="grid"
                localization={MRT_Localization_ES}
                enableColumnDragging={false} //No permite que se arrastren las columnas.
                {...(!soloLectura && {
                  renderRowActionMenuItems: ({ closeMenu, row, }) => [
                    <MenuItem
                      key={0}
                      sx={{ m: 0 }}
                      disabled={row.original.fin_vigencia}
                      onClick={() => {
                        handleClickActualizar(row.original)
                        closeMenu();
                      }}>
                      <ListItemIcon>
                        <AutorenewIcon color="secondary" />
                      </ListItemIcon>
                      Actualizar precio
                    </MenuItem>,
                    <MenuItem
                      key={1}
                      sx={{ m: 0 }}
                      onClick={() => {
                        handleEditar(row.original)
                        closeMenu();
                      }}>
                      <ListItemIcon>
                        <Edit color="primary" />
                      </ListItemIcon>
                      Editar
                    </MenuItem>
                  ]
                })}
              />
            </ThemeProvider>

          </Box>
        ) : null}
        {!soloLectura && actualizar ? (
          <Actualizar_precio_especial
            open={setActualizar}
            tabla={setTabla}
            datosExisten={datoslista}
            actualizar={obtenerLista}
          />
        ) : null}

        {!soloLectura && alta ? (
          <AddPrecioEspecial
            alta={setAlta}
            tabla={setTabla}
          ></AddPrecioEspecial>
        ) : null}

        {!soloLectura && actualizarTodos ?
          <Actualizar_selection
            open={setActualizarTodos}
            tabla={setTabla}
            datosExisten={clienteSeleccionado}
            setDatosExisten={setclienteSeleccionado}
            actualizar={obtenerLista}
            setrowSelection={setrowSelection}
          /> : null}

        {!soloLectura && editar ? (
          <Editar_lista
            open={setEditar}
            tabla={setTabla}
            datosExisten={datoslista}
            actualizar={obtenerLista}

          ></Editar_lista>) : null}

      </Container>
    </div>
  )
}

export default Lista_preciosEspeciales
//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio /Nicolas Pascucci
// Creation Date : 19/6/2024
// Version : 1
// Description : Tabla de lista de precios
//------Changes ----------------------------------------------------------//
// Change by : Candela Grosso
// Change description:  modificaciones varias. modificar directamente des de la tabla

// Change Date :11/09/2024
//========================================================================///------Changes ----------------------------------------------------------//
// Change by : Candela Grosso
// Change description:  ARREGLE LA TABLA UNA VEZ QUE FILTRA , YA QUE SE ROMPIA

// Change Date :29/10/2024
//========================================================================/